module.exports = __webpack_public_path__ + "images/sales_contact_suggestion/wada_ce0be038b33af4c01fe9468e77bddf62.png";